import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { useAcompanhamentosListagem } from '../hooks/useAcompanhamentosListagem';
import { useAcompanhamentosNavegacao } from '../hooks/useAcompanhamentosNavegacao';
import AcompanhamentosHeader from './AcompanhamentosHeader';
import AcompanhamentosFilter from './AcompanhamentosFilter';
import AcompanhamentosTable from './AcompanhamentosTable';

const AcompanhamentosCard = ({
  cargaId,
  depotId,
  showActions = true,
  enableRowClick = true,
  showFilter = true,
  showHeader = true
}) => {
  // Hooks
  const {
    data,
    loading,
    error,
    handleFilterChange,
    totalRegistros,
    pagination,
    setPagination
  } = useAcompanhamentosListagem(cargaId, depotId);
  const {
    handleRowClick,
    handleAdicionar
  } = useAcompanhamentosNavegacao();
  return <Card>
      <CardBody>
        {showHeader && <AcompanhamentosHeader onAdicionar={showActions ? handleAdicionar : undefined} />}
        
        {showFilter && <AcompanhamentosFilter onApply={handleFilterChange} loading={loading} />}

        {error && <div className="alert alert-danger" role="alert">
            {error}
          </div>}

        <AcompanhamentosTable data={data} onRowClick={enableRowClick ? handleRowClick : undefined} loading={loading} manualPagination totalRegistros={totalRegistros} pagination={pagination} onPaginationChange={setPagination} />
      </CardBody>
    </Card>;
};

export default AcompanhamentosCard;
